import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { BanknoteIcon, TrendingUpIcon, UsersIcon, ActivityIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const prepaidRevenueData = [{
  month: 'Jan',
  revenue: 12500000
}, {
  month: 'Feb',
  revenue: 13200000
}, {
  month: 'Mar',
  revenue: 14100000
}, {
  month: 'Apr',
  revenue: 13800000
}, {
  month: 'May',
  revenue: 15200000
}, {
  month: 'Jun',
  revenue: 16500000
}];
export function PrepaidRevenue() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-1832">
      {/* Header */}
      <div className="mb-8" data-id="element-1833">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1834">
          Prepaid Billing Revenue
        </h1>
        <p className="text-gray-500" data-id="element-1835">
          Track and analyze prepaid electricity token sales and collection
          performance.
        </p>
      </div>

      <div className="space-y-8" data-id="element-1836">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1837">
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1838">
            <div className="p-3 bg-mavis-teal/10 text-mavis-teal rounded-none" data-id="element-1839">
              <BanknoteIcon className="w-5 h-5" data-id="element-1840" />
            </div>
            <div data-id="element-1841">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1842">
                YTD Prepaid Revenue
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1843">
                {formatZAR(85300000)}
              </p>
            </div>
          </div>
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1844">
            <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-1845">
              <TrendingUpIcon className="w-5 h-5" data-id="element-1846" />
            </div>
            <div data-id="element-1847">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1848">
                Collection Rate
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1849">98.5%</p>
            </div>
          </div>
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1850">
            <div className="p-3 bg-blue-50 text-blue-600 rounded-none" data-id="element-1851">
              <UsersIcon className="w-5 h-5" data-id="element-1852" />
            </div>
            <div data-id="element-1853">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1854">
                Active Vending Points
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1855">142</p>
            </div>
          </div>
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1856">
            <div className="p-3 bg-mavis-gold/10 text-mavis-gold rounded-none" data-id="element-1857">
              <ActivityIcon className="w-5 h-5" data-id="element-1858" />
            </div>
            <div data-id="element-1859">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1860">
                Avg Token Size
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1861">
                {formatZAR(185)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200" data-id="element-1862">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1863">
            Prepaid Revenue Trend (Last 6 Months)
          </h2>
          <div className="h-80" data-id="element-1864">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1865">
              <AreaChart data={prepaidRevenueData} margin={{
              top: 10,
              right: 10,
              left: 20,
              bottom: 0
            }} data-id="element-1866">

                <defs data-id="element-1867">
                  <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-1868">
                    <stop offset="5%" stopColor="#0D4F5C" stopOpacity={0.3} data-id="element-1869" />
                    <stop offset="95%" stopColor="#0D4F5C" stopOpacity={0} data-id="element-1870" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-1871" />

                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} dy={10} data-id="element-1872" />

                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} tickFormatter={val => `R${(val / 1000000).toFixed(1)}M`} data-id="element-1873" />

                <Tooltip formatter={(value: number) => [formatZAR(value), 'Revenue']} contentStyle={{
                borderRadius: '0',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-1874" />

                <Area type="monotone" dataKey="revenue" stroke="#0D4F5C" strokeWidth={2} fillOpacity={1} fill="url(#colorRevenue)" data-id="element-1875" />

              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}